import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RegistrationDialogBoxComponent } from '../registration-dialog-box/registration-dialog-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
import { RegnExamDataComponent } from '../regn-exam-data/regn-exam-data.component';
import { RegnExamSubComponent } from '../regn-exam-sub/regn-exam-sub.component';
import { DatePipe } from '@angular/common';
import { SearchExamSubComponent } from '../search-exam-sub/search-exam-sub.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-search-exam-forms',
  templateUrl: './search-exam-forms.component.html',
  styleUrls: ['./search-exam-forms.component.scss']
})
export class SearchExamFormsComponent implements OnInit {
  APIService: string;
  SessionNo: any;
  examscheduleList: any;
  filteredListExamSch: any;
  dialogRef: MatDialogRef<any>;
  SearchExamForm: FormGroup;
  ConstiCateList: any;
  filteredConstiCateList: any;
  filteredCollegeList: any;
  collegeList: any[];
  genderList: any;
  filteredGenderList: any;
  streamList: any;
  filteredStreamList: any;
  GridData: any;
  Table = false;
  selectedRow: any;
  constructor(
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder,
    public router: Router,
    public datepipe: DatePipe,
    private dialog: MatDialog, private location: Location,
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
      this.getExmSchData(this.SessionNo);
    }
    this.Table = false;
    this.SearchExamForm = this.fb.group({
      ShId: new FormControl(''),
      RgNo: new FormControl(''),
      EfCate: new FormControl(''),
      CgCode: new FormControl(''),
      Cent: new FormControl(''),
      RollNo: new FormControl(''),
      RgName: new FormControl(''),
      Sex: new FormControl(''),
      StrCode: new FormControl(''),
      PassFail: new FormControl(''),
      EfStatus: new FormControl(''),
      EfBatch: new FormControl(''),
      WH: new FormControl(''),
      Inc: new FormControl(''),
      Decl: new FormControl(''),
      EfPCFr: new FormControl(''),
      EfPCTo: new FormControl('')


    });
    this.fetchSecretData();
    this.fetchConstiCate();
    this.getCollegeData();
    this.fetchGender();
    this.getBranch();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo'];
      this.getExmSchData(this.SessionNo);
      }
    );
  }

  getExmSchData(SnNo) {
    this.spinner.show();
    const payload = {};
    payload['ShStatus'] = '';
    payload['LoginId'] = 0;
    payload['ShSnNo'] = SnNo
    this.umsService.getExmSch(payload).subscribe(res => {
      this.spinner.hide();
      this.examscheduleList = res.data;
      this.filteredListExamSch = this.examscheduleList.slice();
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.examscheduleList = [];
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
  }

  fetchConstiCate() {
    const payload = {};
    payload['CdType'] = 'CT';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.ConstiCateList = res.data;
        this.filteredConstiCateList = this.ConstiCateList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  getCollegeData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
    
    },(ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }

  fetchGender() {
    const payload = {};
    payload['CdType'] = 'SX';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.genderList = res.data;
        this.filteredGenderList = this.genderList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  getBranch(){
    this.spinner.show();
    let payload = {};
    payload['CoCode'] = '';
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe((res) => {
      this.spinner.hide();
      if(res.data.length > 0){
      }
      else{
      }
      if (res.status) {
        this.streamList = res.data;
        this.filteredStreamList = this.streamList.slice();
      }
      
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getData(){
    this.GridData = []
    this.Table = false
    this.spinner.show();
    const payload = this.SearchExamForm.value;
    this.umsService.searchExmList(payload).subscribe((res) => {
      this.spinner.hide();
      if(res.status){
      this.GridData = res.data
        this.Table = true;
      }else{
        this.Table = false
      }
      
    
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.Table = false;
      this.GridData = []
    })
  }

  selected(data){
    this.selectedRow = data;
    // if(data.ExamsAvailable == 0){
    //   this.SubBtn = true;
    //   this.ExmBtn = true
    // }
    // else{
    //   this.SubBtn = false
    //   this.ExmBtn = false
    // }
    this.Sub()
  }

  Sub(){
    const dialogRef = this.dialog.open(SearchExamSubComponent, {
      width: '130vh',
      disableClose: true,
      data: this.selectedRow
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getData();
    });
  }
  print(){
    let submitpayload = this.SearchExamForm.value;
    let payload1 = {}
    payload1['MenuName'] = 'SearchExamForm';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 130,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }
  redirect(to): void {
    this.router.navigate([to]);
  }
  

  reset(){
    this.SearchExamForm.reset();
    this.Table = false
  }

  Back(){
    this.goBack();
   }
   goBack(): void {
    this.location.back(); // This will navigate back to the previous page
  }
}
